import { Box, Button, TextField } from "@mui/material";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { db } from "../../firebase";

export default function ConfigScreen() {
  // const { state } = useLocation();
  // const history = useHistory();
  // console.log(state.v);
  const { enqueueSnackbar } = useSnackbar();

  const [values, setValues] = React.useState({ v: "", d: "" });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: parseFloat(event.target.value)
        ? parseFloat(event.target.value)
        : event.target.value,
    });
  };

  const rateRef = doc(db, "config", "rate");

  useEffect(() => {
    getDoc(rateRef).then((snapshot) => {
      // console.log(snapshot.data().v);
      setValues(snapshot.data());
    });
  }, []);

  /* const handleClick = () => {
    // push data in router
    history.push("/config", { v: 98 });
  }; */

  const setRate = () => {
    setDoc(rateRef, values).then(() => {
      console.log("Document updated");
      enqueueSnackbar("Updated", { variant: "success" });
    });
  };

  return (
    <div>
      <Box sx={{ maxWidth: 200 }}>
        <div>
          <TextField
            className="inputRounded"
            sx={{ mb: 2 }}
            fullWidth
            label="Dollar Rate (SSP)"
            value={values.v}
            type="number"
            variant="outlined"
            onChange={handleChange("v")}
          />
        </div>

        <div>
          <TextField
            className="inputRounded"
            sx={{ mb: 2 }}
            fullWidth
            label="Delivery Discount (%)"
            value={values.d}
            type="number"
            InputProps={{ inputProps: { min: 0, max: 100 } }}
            variant="outlined"
            onChange={handleChange("d")}
          />
        </div>

        <Button
          fullWidth
          variant="contained"
          onClick={setRate}
          disableElevation
          sx={{ height: 40, borderRadius: 1 }}
        >
          Update
        </Button>
      </Box>
    </div>
  );
}
